module.exports = __webpack_public_path__ + "img/search.881c1d60.svg";